<template>
  <div>
    <img :src="src" class="contrast_img" @click="openPreview">
    <el-dialog class="main_dialog" :visible.sync="dialogTableVisible" width="80%">
      <template slot="title">
        <el-input-number v-model="scaleNum" @change="handleScaleChange" :min="25" :precision="0"></el-input-number>
      </template>
      <div class="preview_box" @mousewheel.prevent="handleMouseScaleChange">
        <div class="image_box" @mouseenter="isHover = true" @mouseup.stop="isMousedown = false" @mouseleave="isHover = isMousedown = false" @mousemove="handleDragMove">
          <img ref="originalImageRef" :src="originSrc" @mousedown="handleDragStart">
        </div>
        <div class="image_box">
          <img ref="currentImageRef" :src="src">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "imageContrast",
  props: {
    src: {
      type: String,
      default: ""
    },
    originSrc: {
      type: String,
      default: ""
    }
  },
  data () {
   return {
    dialogTableVisible: false,
    scaleNum: 100,
    moveStart: {
      x: 0,
      y: 0
    },
    translate: {
      x: 0,
      y: 0
    },
    currentRef: null,
    isHover: false,
    isMousedown: false,
   }
  },
  methods:{
    openPreview() {
      this.dialogTableVisible = true
    },
    handleScaleChange(val) {
      this.$refs.originalImageRef.style.transform = `scale(${this.scaleNum / 100}) translate(${this.translate.x}px, ${this.translate.y}px)`
      this.$refs.currentImageRef.style.transform = `scale(${this.scaleNum / 100}) translate(${this.translate.x}px, ${this.translate.y}px)`
    },
    handleMouseScaleChange(event) {
      let speed = event.wheelDelta / 12
      if(event.wheelDelta < 0 && this.scaleNum > 25) {
        this.scaleNum += speed
        this.handleScaleChange()
      }else if(event.wheelDelta > 0 && this.scaleNum < 500) {
        this.scaleNum += speed
        this.handleScaleChange()
      }
      
    },
    handleDragStart(event) {
      event.preventDefault()
      this.moveStart.x = event.clientX
      this.moveStart.y = event.clientY
      this.isMousedown = true
    },
    handleDragMove(event) {
      if(this.isMousedown) {
        this.translate.x += (event.clientX - this.moveStart.x) / (this.scaleNum / 100)
        this.translate.y += (event.clientY - this.moveStart.y) / (this.scaleNum / 100)
        this.$refs.originalImageRef.style.transform = `scale(${this.scaleNum / 100}) translate(${this.translate.x}px, ${this.translate.y}px)`
        this.$refs.currentImageRef.style.transform = `scale(${this.scaleNum / 100}) translate(${this.translate.x}px, ${this.translate.y}px)`
        this.moveStart.x = event.clientX
        this.moveStart.y = event.clientY
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.main_dialog /deep/ .el-dialog {
  height: 70vh;
  min-height: 500px;
  .el-dialog__header {
    text-align: center;
    border-bottom: none;
  }
  .el-dialog__body {
    height: calc(100% - 88px);
    .preview_box {
      display: flex;
      justify-content: space-between;
      height: 100%;
      .image_box {
        width: 49%;
        height: 100%;
        overflow: hidden;
        text-align: center;
        // -webkit-user-drag: none;
        // user-drag: none;
        // user-select: none;
        // pointer-events: none;
        img {
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>